<script>
export default {
  props: {
    item: {
      type: Object
    },
    attrs: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      color: 'green'
    }
  },
  computed: {
    icons() {
      const icons = []
      const {duplicates, attachments, coverSheetStatus, coverSheetId} = this.item
      if (duplicates && duplicates.length) {
        icons.push({name: 'mdi-content-copy', color: '#d90f0f'})
      }
      if (attachments && attachments?.length) {
        icons.push({name: 'mdi-paperclip', color: 'green', amount: attachments?.length})
      }
      if (coverSheetId !== null || (coverSheetStatus && coverSheetStatus === 200)) {
        icons.push({name: 'mdi-file-document-outline', color: '#2196f3'})
      }
      return icons
    }
  },
  methods: {
    addEventAttrs(event) {
      this.$emit('created', {
        event: event,
        menu: this.attrs.menu,
        attrs: this.attrs.attrs
      })
      this.item.menuEvent = this.attrs.menu
      this.item.menuAttrs = this.attrs.attrs
    },
    getPaddingRight(amount) {
      return `${18 + Math.floor(amount / 10) * 6}px`;
    }
  }
}
</script>
<template>
  <span>
    <span v-for="(icon, index) in icons" :key="index" style="position:relative">
       <v-chip
         v-if="icon.amount"
         :filter-icon="icon.name"
         x-small
         :color="icon.color"
         :style="`position: absolute;top:${(-6)+8*index}px;left:${30}px;padding-right:${getPaddingRight(icon.amount)};`">
        <v-icon
          color="white"
          style="font-size:8px;position:absolute;top:4px;left:3px;"
          v-on="{ ...attrs.tooltip, ...attrs.menu }"
          @click="addEventAttrs">
          {{ icon.name }}
        </v-icon>
           <span style="font-size:8px;color:white;">
            + {{ icon.amount }}
           </span>
        </v-chip>
      <span
        v-else
        :style="`background: ${icon.color};border-radius:50%;width:14px;height:14px;position:absolute;top:${(-6)+8*index}px;left:${30}px;padding:2px;`">
        <v-icon
          color="white"
          style="font-size:8px;position:absolute;top:3px;left:3px;"
          v-on="{ ...attrs.tooltip, ...attrs.menu }"
          @click="addEventAttrs">
          {{ icon.name }}
        </v-icon>
      </span>
    </span>
    <v-btn
      :id="`upload_validation_tooltip_${item.documentId}`"
      :disabled="disabled"
      color="primary"
      class="d-inline"
      icon
      large
      v-on="{ ...attrs.tooltip, ...attrs.menu }"
      @click="addEventAttrs">
      <v-icon>mdi-view-list-outline</v-icon>
    </v-btn>
  </span>
</template>
